import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';

export const PrivacyPolicy = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-50 to-white py-24">
      <div className="max-w-4xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="bg-white/60 backdrop-blur-sm rounded-3xl p-12 border border-white/20 shadow-2xl"
        >
          <div className="text-center mb-12">
            <h1 className="text-4xl lg:text-5xl font-black mb-6 bg-gradient-to-r from-green-600 to-teal-600 bg-clip-text text-transparent">
              {t('legal.privacy_title')}
            </h1>
            <p className="text-slate-600 text-lg">
              {t('legal.last_updated')} {new Date().toLocaleDateString()}
            </p>
          </div>

          <div className="prose prose-slate max-w-none space-y-8">
            <section>
              <h2 className="text-2xl font-bold text-slate-800 mb-4">{t('legal.privacy_intro_title')}</h2>
              <p className="text-slate-600 leading-relaxed">
                {t('legal.privacy_intro_text')}
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-slate-800 mb-4">{t('legal.privacy_data_title')}</h2>
              
              <div className="space-y-4">
                <div>
                  <h3 className="text-lg font-semibold text-slate-700 mb-2">{t('legal.privacy_personal_title')}</h3>
                  <p className="text-slate-600 leading-relaxed">{t('legal.privacy_personal_text')}</p>
                </div>
                
                <div>
                  <h3 className="text-lg font-semibold text-slate-700 mb-2">{t('legal.privacy_technical_title')}</h3>
                  <p className="text-slate-600 leading-relaxed">{t('legal.privacy_technical_text')}</p>
                </div>
                
                <div>
                  <h3 className="text-lg font-semibold text-slate-700 mb-2">{t('legal.privacy_content_title')}</h3>
                  <p className="text-slate-600 leading-relaxed">{t('legal.privacy_content_text')}</p>
                </div>
                
                <div>
                  <h3 className="text-lg font-semibold text-slate-700 mb-2">{t('legal.privacy_children_title')}</h3>
                  <p className="text-slate-600 leading-relaxed">{t('legal.privacy_children_text')}</p>
                </div>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-slate-800 mb-4">{t('legal.privacy_use_title')}</h2>
              <div className="space-y-3">
                <p className="text-slate-600 leading-relaxed">{t('legal.privacy_use_service')}</p>
                <p className="text-slate-600 leading-relaxed">{t('legal.privacy_use_marketing')}</p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-slate-800 mb-4">{t('legal.privacy_sharing_title')}</h2>
              <p className="text-slate-600 leading-relaxed">
                {t('legal.privacy_sharing_text')}
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-slate-800 mb-4">{t('legal.privacy_security_title')}</h2>
              <p className="text-slate-600 leading-relaxed">
                {t('legal.privacy_security_text')}
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-slate-800 mb-4">{t('legal.privacy_retention_title')}</h2>
              <p className="text-slate-600 leading-relaxed">
                {t('legal.privacy_retention_text')}
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-slate-800 mb-4">{t('legal.privacy_rights_title')}</h2>
              <div className="space-y-3">
                <p className="text-slate-600 leading-relaxed">{t('legal.privacy_rights_access')}</p>
                <p className="text-slate-600 leading-relaxed">{t('legal.privacy_rights_objection')}</p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-slate-800 mb-4">{t('legal.privacy_international_title')}</h2>
              <p className="text-slate-600 leading-relaxed">
                {t('legal.privacy_international_text')}
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-slate-800 mb-4">{t('legal.privacy_cookies_title')}</h2>
              <p className="text-slate-600 leading-relaxed">
                {t('legal.privacy_cookies_text')}
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-slate-800 mb-4">{t('legal.privacy_changes_title')}</h2>
              <p className="text-slate-600 leading-relaxed">
                {t('legal.privacy_changes_text')}
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-slate-800 mb-4">{t('legal.privacy_contact_title')}</h2>
              <p className="text-slate-600 leading-relaxed">
                {t('legal.privacy_contact_text')}
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-slate-800 mb-4">{t('legal.privacy_complaints_title')}</h2>
              <p className="text-slate-600 leading-relaxed">
                {t('legal.privacy_complaints_text')}
              </p>
            </section>

            <section className="border-t border-slate-200 pt-6">
              <p className="text-slate-500 text-sm italic">
                {t('legal.effective_date')}
              </p>
            </section>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;